"use client";

import Icon from "@/components/icons/Icons";
import { useIsMobile } from "@/utils/useIsMobile";
import { AnimatePresence, motion } from "framer-motion";

interface StepNavigationProps {
  currentStep: number;
  totalSteps?: number;

  onBack?: () => void;
  onContinue?: () => void;

  hideBackUntilStep?: number;

  continueText?: string;
  backText?: string;

  isLoading?: boolean;
  disabled?: boolean;
}

export default function StepNavigation({
  currentStep,
  onBack,
  onContinue,
  hideBackUntilStep = 1,
  continueText = "Continue",
  backText = "Back",
  isLoading = false,
  disabled = false,
}: StepNavigationProps) {
  const showBack = currentStep > hideBackUntilStep;
  const isMob = useIsMobile(631);

  return (
    <div className="flex gap-3 xs:gap-4 items-center justify-center mt-4 sm:mt-6">
      <AnimatePresence mode="wait">
        {showBack && (
          <motion.button
            key="back-button"
            type="button"
            disabled={currentStep == hideBackUntilStep}
            onClick={onBack}
            initial={{
              opacity: 0,
              maxWidth: 0,
            }}
            animate={{
              opacity: 1,
              maxWidth: isMob ? "116px" : "156px",
            }}
            exit={{
              opacity: 0,
              maxWidth: 0,
            }}
            transition={{
              duration: 0.25,
              ease: "easeInOut",
            }}
            className="overflow-hidden w-full py-3 lg:py-3.5 flex items-center justify-center gap-3 rounded-full border sm:border-2 border-white lg:text-xl leading-1.3! font-semibold text-white transition hover:bg-white/15"
          >
            <Icon.rightArrow className="w-3.5 h-3.5 lg:w-5 lg:h-5 rotate-180 shrink-0" /> {backText}
          </motion.button>
        )}
      </AnimatePresence>

      <button
        type="button"
        onClick={onContinue}
        disabled={disabled || isLoading}
        className="overflow-hidden w-full max-w-80 py-3 lg:py-3.5 flex items-center justify-center gap-3 rounded-full border sm:border-2 border-white bg-white lg:text-xl leading-1.3! font-semibold text-primaryBlue transition sm:hover:text-white sm:hover:bg-white/15"
      >
        {isLoading ? "Loading..." : continueText}
      </button>
    </div>
  );
}
